import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import stagesApi from "../api/stageApi";
import { EDITED_SUCCESS_MSG } from "../../../../core/data/constants/constant";
import { handleModalAction } from "../../../../utils/helpers/handleModalAction";
import { isSuperAdmin } from "../../../../utils/helpers/helper";

const EditStageModal = ({ stageData, selectedCompany, user }) => {
  console.log("EditStageModal - stageData:", stageData);
  
  const queryClient = useQueryClient();

  // Validation schema using Yup
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Stage Name is required"),
  });

  const mutationEditStage = useMutation({
    mutationFn: (updatedStageData) => {

      if (updatedStageData.autoUpdateKeys.length !== updatedStageData.autoUpdateValues.length) {
    //  toast.error("Please select key and value for auto update fields.");   
        return Promise.reject(new Error("Key and value mismatch for auto update fields."));
      }else if (updatedStageData.autoUpdateKeys.length === 0) {
        // If no auto update fields are selected, set update to an empty object 
        updatedStageData.update = {};
      } else {
        // Create an update object from the selected keys and values
        updatedStageData.update = updatedStageData.autoUpdateKeys.reduce(
          (acc, key, index) => {
            acc[key] = updatedStageData.autoUpdateValues[index];
            return acc;
          },
          {}
        );
      }

      const requestData = {
        id: updatedStageData.id,
        name: updatedStageData.name,
        ofCompany: isSuperAdmin(user) ? selectedCompany : user?.ofCompany?._id,
        module: updatedStageData.module,
        postUpdate: updatedStageData.update || {},
        postAction: updatedStageData.postAction || {},
      };
      return stagesApi.updateStage(requestData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries("stages");
      toast.success(EDITED_SUCCESS_MSG);
      handleModalAction("edit_stage", "hide");
    },
    onError: (error) => {
      toast.error(error.response?.data?.msg || "Failed to update stage.");
    },
  });

  const formik = useFormik({
    initialValues: {
      name: stageData?.name || "",
      color: stageData?.color || "",
      id: stageData?.id || "",
      module: stageData?.module || "",
      autoUpdateKeys : Object.keys(stageData?.postUpdate || {}) || [],
      autoUpdateValues : Object.values(stageData?.postUpdate|| {}) || [],
      postAction: stageData?.postAction || {},
    },
    validationSchema,
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values) => {
      
   
      if (
        values.name === stageData?.name &&
        values.color === stageData?.color &&
        values.module === stageData?.module &&
        JSON.stringify(values.autoUpdateKeys) === JSON.stringify(
          Object.keys(stageData?.postUpdate || {})
        ) &&
        JSON.stringify(values.autoUpdateValues) === JSON.stringify(
          Object.values(stageData?.postUpdate || {}
          )
        
      ) && 
        JSON.stringify(values.postAction) === JSON.stringify(
          stageData?.postAction || {}
        )
      ) {
        toast.warn("No changes detected.");
        return;
      }
      // Check if autoUpdateKeys and autoUpdateValues have the same length
      if (values.autoUpdateKeys.length !== values.autoUpdateValues.length) {
        toast.error("Please select key and value for auto update fields.");
        return;
      }

      mutationEditStage.mutate(values);
    },
  });

  return (
    <div className="modal fade" id="edit_stage" role="dialog">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Stage</h5>
            <Link to="#" className="btn btn-light me-2" data-bs-dismiss="modal">
              <i className="ti ti-x" />
            </Link>
          </div>
          <div className="modal-body">
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-3 position-relative">
                <label className="col-form-label">
                  Stage Name <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    className={`form-control ${
                      formik.errors.name && formik.touched.name
                        ? "is-invalid"
                        : ""
                    }`}
                  />

                  <div className="input-group-text">
                    <i className="ti ti-pencil" />
                  </div>
                </div>
                {formik.errors.name && formik.touched.name && (
                  <div className="text-danger small mt-1">
                    {formik.errors.name}
                  </div>
                )}
              </div>

              {/* i want to add update field like {probability : high} build two dropdown that will update autoupdatekeys and auto update values*/}
<div className="mb-3">
  <label className="form-label">
    Auto Update Fields 
  </label>
  <select
    className="form-select"
    name="autoUpdateKeys"
    value={formik.values.autoUpdateKeys}
    onChange={(e) => {
      const selectedOptions = Array.from(e.target.selectedOptions).map(
        (option) => option.value
      );
      console.log("Selected Options:", selectedOptions);
      formik.setFieldValue("autoUpdateKeys", selectedOptions);
    }}
    
  >
    <option value="">Select Fields</option>
    <option value="probability">Probability</option>
    {/* <option value="status">Status</option>
    <option value="priority">Priority</option>
    <option value="assignedTo">Assigned To</option>
    <option value="dueDate">Due Date</option>
    <option value="tags">Tags</option>
    <option value="customField">Custom Field</option> */}
    {/* Add more options as needed */}
  </select>
</div>

              <div className="mb-3 position-relative">
                <label className="col-form-label">
                  Auto Update Values  
                </label>
                <div className="input-group">
                  <select
                    name="autoUpdateValues"
                    value={formik.values.autoUpdateValues}
                    onChange={(e) => {
                      const selectedOptions = Array.from(
                        e.target.selectedOptions,
                      ).map((option) => option.value);
                      console.log("Selected Options:", selectedOptions);
                      formik.setFieldValue("autoUpdateValues", selectedOptions);
                    }}
                    className={`form-select ${
                      formik.errors.autoUpdateValues &&
                      formik.touched.autoUpdateValues
                        ? "is-invalid"
                        : ""
                    }`}
                    
                  >
                    <option value="">Select Values</option>
                    <option value="high">High</option>
                    <option value="medium">Medium</option>
                    <option value="low">Low</option>
                    {/* <option value="open">Open</option>
                    <option value="closed">Closed</option>
                    <option value="in-progress">In Progress</option>
                    <option value="completed">Completed</option>
                    <option value="assigned">Assigned</option>
                    <option value="unassigned">Unassigned</option>
                    <option value="tag1">Tag 1</option>
                    <option value="tag2">Tag 2</option>
                    <option value="customValue1">Custom Value 1</option>
                    <option value="customValue2">Custom Value 2</option> */}
                    {/* Add more options as needed */}
                  </select>
               
                </div>
              
              </div>

             {/* now we need to add post action update checkboxes with label */}
<div className="mb-3">
  <label className="col-form-label">
    Post Actions
  </label>
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      id="autoOpenReminder"
      name="postAction.autoOpenReminder"
      checked={formik.values.postAction?.autoOpenReminder || false}
      onChange={(e) => {
        formik.setFieldValue("postAction", {
          ...formik.values.postAction,
          autoOpenReminder: e.target.checked,
        });
      }}
    />
    <label className="form-check-label" htmlFor="autoOpenReminder">
      Open Follow-Up Reminder Dialog Automatically
    </label>
  </div>
  {/* Add more checkboxes here as needed */}
</div>




             

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={mutationEditStage?.isPending}
                >
                  {mutationEditStage?.isPending ? "Saving" : "Save Changes"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditStageModal;
